import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.pad-end.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import * as signalR from '@microsoft/signalr';
import store from '@/store';
import { Message } from 'element-ui';
import { getToken as getStoredToken } from '@/utils/auth';
import { refreshAccessToken } from '@/utils/token-refresh';
var SignalRService = /*#__PURE__*/function () {
  function SignalRService() {
    _classCallCheck(this, SignalRService);
    this.connection = null;
    this.isConnected = false;
    this.reconnectDelay = 2000; // 初始重连延迟
    this.maxReconnectDelay = 30000; // 最大重连延迟
    this.reconnectTimer = null;
    this.heartbeatTimer = null; // 新增：心跳定时器
    this.connectionMonitorTimer = null; // 新增：连接监控定时器
    // 用于存储已显示的通知ID
    this.displayedNotifications = new Set();
    // 从localStorage加载已显示的通知
    this.loadDisplayedNotifications();
    this.latestToken = getStoredToken() || null;
    this.forceRefreshOnNextConnect = false;
  }

  // 从localStorage加载已显示的通知
  return _createClass(SignalRService, [{
    key: "loadDisplayedNotifications",
    value: function loadDisplayedNotifications() {
      try {
        var stored = localStorage.getItem('displayedNotifications');
        if (stored) {
          var storedArray = JSON.parse(stored);
          this.displayedNotifications = new Set(storedArray);

          // 可选：清除过期的通知记录（例如存储超过100条时）
          if (this.displayedNotifications.size > 100) {
            this.clearOldNotifications();
          }
        }
      } catch (error) {
        console.error('加载已显示通知失败:', error);
        this.displayedNotifications = new Set();
      }
    }

    // 保存已显示的通知到localStorage
  }, {
    key: "saveDisplayedNotifications",
    value: function saveDisplayedNotifications() {
      try {
        var notificationsArray = Array.from(this.displayedNotifications);
        localStorage.setItem('displayedNotifications', JSON.stringify(notificationsArray));
      } catch (error) {
        console.error('保存已显示通知失败:', error);
      }
    }

    // 清除旧的通知记录，只保留最近的50条
  }, {
    key: "clearOldNotifications",
    value: function clearOldNotifications() {
      var notificationsArray = Array.from(this.displayedNotifications);
      if (notificationsArray.length > 50) {
        var recentNotifications = notificationsArray.slice(-50);
        this.displayedNotifications = new Set(recentNotifications);
        this.saveDisplayedNotifications();
      }
    }

    // 检测和处理WebSocket连接问题
  }, {
    key: "checkWebSocketSupport",
    value: function checkWebSocketSupport() {
      // 检测浏览器是否支持WebSocket
      if (!window.WebSocket) {
        console.warn('当前浏览器不支持WebSocket，将使用备用传输方式');
        return false;
      }

      // 尝试创建一个简单的WebSocket连接测试
      try {
        var testWs = new WebSocket("wss://".concat(window.location.host, "/ws-test"));
        testWs.onopen = function () {
          testWs.close();
        };
        testWs.onerror = function (event) {
          console.warn('WebSocket测试连接失败，可能存在网络限制:', event);
        };
        return true;
      } catch (e) {
        console.warn('WebSocket连接测试失败:', e);
        return false;
      }
    }
  }, {
    key: "resolveToken",
    value: function resolveToken(providedToken) {
      var _store$state;
      if (providedToken) {
        this.latestToken = providedToken;
        return providedToken;
      }
      var storeToken = store === null || store === void 0 || (_store$state = store.state) === null || _store$state === void 0 || (_store$state = _store$state.user) === null || _store$state === void 0 ? void 0 : _store$state.token;
      if (storeToken) {
        this.latestToken = storeToken;
        return storeToken;
      }
      if (this.latestToken) {
        return this.latestToken;
      }
      var savedToken = getStoredToken();
      if (savedToken) {
        this.latestToken = savedToken;
        return savedToken;
      }
      return null;
    }
  }, {
    key: "parseTokenPayload",
    value: function parseTokenPayload(token) {
      if (!token) {
        return null;
      }
      try {
        var payload = token.split('.')[1];
        if (!payload) {
          return null;
        }
        payload = payload.replace(/-/g, '+').replace(/_/g, '/');
        var paddedPayload = payload.padEnd(payload.length + (4 - payload.length % 4) % 4, '=');
        return JSON.parse(window.atob(paddedPayload));
      } catch (error) {
        console.warn('[SignalR] 解析 token 失败:', error);
        return null;
      }
    }
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(token) {
      var bufferSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
      var payload = this.parseTokenPayload(token);
      if (!(payload !== null && payload !== void 0 && payload.exp)) {
        return false;
      }
      var now = Math.floor(Date.now() / 1000);
      return payload.exp <= now + bufferSeconds;
    }
  }, {
    key: "getConnectionToken",
    value: function () {
      var _getConnectionToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(providedToken) {
        var forceRefresh,
          currentToken,
          _yield$refreshAccessT,
          accessToken,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              forceRefresh = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              currentToken = this.resolveToken(providedToken);
              if (currentToken) {
                _context.n = 1;
                break;
              }
              return _context.a(2, null);
            case 1:
              if (!(!forceRefresh && !this.isTokenExpired(currentToken))) {
                _context.n = 2;
                break;
              }
              return _context.a(2, currentToken);
            case 2:
              _context.p = 2;
              _context.n = 3;
              return refreshAccessToken();
            case 3:
              _yield$refreshAccessT = _context.v;
              accessToken = _yield$refreshAccessT.accessToken;
              this.latestToken = accessToken;
              this.forceRefreshOnNextConnect = false;
              return _context.a(2, accessToken);
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.warn('[SignalR] 刷新连接令牌失败:', _t);
              this.forceRefreshOnNextConnect = false;
              if (!(!forceRefresh && !this.isTokenExpired(currentToken, 0))) {
                _context.n = 5;
                break;
              }
              return _context.a(2, currentToken);
            case 5:
              return _context.a(2, null);
          }
        }, _callee, this, [[2, 4]]);
      }));
      function getConnectionToken(_x) {
        return _getConnectionToken.apply(this, arguments);
      }
      return getConnectionToken;
    }()
  }, {
    key: "shouldRefreshForClose",
    value: function shouldRefreshForClose(error) {
      var message = "".concat(error || '').toLowerCase();
      return message.includes('401') || message.includes('unauthorized') || message.includes('forbidden');
    }
  }, {
    key: "createConnection",
    value: function createConnection() {
      var _this = this;
      return new signalR.HubConnectionBuilder().withUrl('api/v5/hubs/online?userType=1', {
        accessTokenFactory: function () {
          var _accessTokenFactory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            var token;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return _this.getConnectionToken(null, _this.forceRefreshOnNextConnect);
                case 1:
                  token = _context2.v;
                  if (token) {
                    _context2.n = 2;
                    break;
                  }
                  throw new Error('signalr token missing');
                case 2:
                  return _context2.a(2, token);
              }
            }, _callee2);
          }));
          function accessTokenFactory() {
            return _accessTokenFactory.apply(this, arguments);
          }
          return accessTokenFactory;
        }(),
        transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling,
        skipNegotiation: false,
        serverTimeoutInMilliseconds: 120000,
        keepAliveIntervalInMilliseconds: 15000
      }).configureLogging({
        log: function log(logLevel, message) {
          var timestamp = new Date().toLocaleString('zh-CN', {
            timeZone: 'Asia/Shanghai',
            hour12: false
          });
          switch (logLevel) {
            case signalR.LogLevel.Error:
              console.error("[".concat(timestamp, "] SignalR\u9519\u8BEF: ").concat(message));
              break;
            case signalR.LogLevel.Warning:
              console.warn("[".concat(timestamp, "] SignalR\u8B66\u544A: ").concat(message));
              break;
            case signalR.LogLevel.Information:
              break;
            case signalR.LogLevel.Debug:
              break;
            default:
              break;
          }
        }
      }).withAutomaticReconnect({
        nextRetryDelayInMilliseconds: function nextRetryDelayInMilliseconds(retryContext) {
          var delay = _this.reconnectDelay * Math.pow(2, retryContext.previousRetryCount);
          delay = Math.min(delay, _this.maxReconnectDelay);
          return delay;
        }
      }).build();
    }
  }, {
    key: "attachConnectionHandlers",
    value: function attachConnectionHandlers() {
      var _this2 = this;
      if (!this.connection) return;
      this.registerEventHandlers();
      this.connection.onreconnecting(function () {
        _this2.isConnected = false;
      });
      this.connection.onreconnected(function () {
        if (_this2.reconnectTimer) {
          clearTimeout(_this2.reconnectTimer);
          _this2.reconnectTimer = null;
        }
        _this2.isConnected = true;
        _this2.reconnectCount = 0;
        store.dispatch('dashboard/refreshTodoList');
        store.dispatch('chat/loadChats');
        _this2.startHeartbeat();
        _this2.startConnectionMonitor();
      });
      this.connection.onclose(function (error) {
        console.warn('[SignalR] 连接已关闭', error ? "\u539F\u56E0: ".concat(error) : '');
        _this2.isConnected = false;
        _this2.reconnectCount = 0;
        _this2.forceRefreshOnNextConnect = _this2.shouldRefreshForClose(error);
        _this2.reconnect();
      });
    }

    // 初始化连接
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(token) {
        var authToken, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!this.connection) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return this.getConnectionToken(token);
            case 2:
              authToken = _context3.v;
              if (authToken) {
                _context3.n = 3;
                break;
              }
              console.error('[SignalR] 初始化失败：未获取到有效 token');
              return _context3.a(2);
            case 3:
              this.connection = this.createConnection();
              this.attachConnectionHandlers();

              // 启动连接
              _context3.p = 4;
              _context3.n = 5;
              return this.connection.start();
            case 5:
              // console.log('SignalR connected')
              if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
              }
              this.isConnected = true;
              this.reconnectCount = 0;

              // 新增：启动心跳和连接监控
              this.startHeartbeat();
              this.startConnectionMonitor();

              // 添加网络状态监听
              this.listenToNetworkChanges();
              _context3.n = 7;
              break;
            case 6:
              _context3.p = 6;
              _t2 = _context3.v;
              console.error('SignalR Connection Error:', _t2);
              this.forceRefreshOnNextConnect = this.shouldRefreshForClose(_t2);
              this.reconnect();
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[4, 6]]);
      }));
      function init(_x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }() // 修改心跳机制
  }, {
    key: "startHeartbeat",
    value: function startHeartbeat() {
      var _this3 = this;
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
      }
      var pingServer = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
          var _t3;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                if (!(!_this3.connection || _this3.connection.state !== signalR.HubConnectionState.Connected)) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2);
              case 1:
                _context4.p = 1;
                _context4.n = 2;
                return _this3.connection.invoke('Ping');
              case 2:
                _context4.n = 4;
                break;
              case 3:
                _context4.p = 3;
                _t3 = _context4.v;
                console.error('心跳失败:', _t3);
                if (_this3.isConnected) {
                  _this3.isConnected = false;
                  _this3.reconnect();
                }
              case 4:
                return _context4.a(2);
            }
          }, _callee4, null, [[1, 3]]);
        }));
        return function pingServer() {
          return _ref.apply(this, arguments);
        };
      }();

      // 立即执行一次心跳
      pingServer();

      // 设置定时心跳，10秒一次
      this.heartbeatTimer = setInterval(pingServer, 10000);
    }

    // 新增：启动连接监控
  }, {
    key: "startConnectionMonitor",
    value: function startConnectionMonitor() {
      var _this4 = this;
      // 清除现有监控
      if (this.connectionMonitorTimer) {
        clearInterval(this.connectionMonitorTimer);
      }

      // 每分钟检查一次连接状态
      this.connectionMonitorTimer = setInterval(function () {
        var _this4$connection;
        // console.log('检查SignalR连接状态:', this.connection?.state)

        if (!_this4.isConnected || ((_this4$connection = _this4.connection) === null || _this4$connection === void 0 ? void 0 : _this4$connection.state) !== signalR.HubConnectionState.Connected) {
          // console.log('检测到连接断开，尝试重连...')
          _this4.reconnect();
        }
      }, 60000); // 60秒间隔
    }

    // 断开连接
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              // 清除所有定时器
              if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
              }
              if (this.heartbeatTimer) {
                clearInterval(this.heartbeatTimer);
                this.heartbeatTimer = null;
              }
              if (this.connectionMonitorTimer) {
                clearInterval(this.connectionMonitorTimer);
                this.connectionMonitorTimer = null;
              }
              if (!this.connection) {
                _context5.n = 5;
                break;
              }
              _context5.p = 1;
              _context5.n = 2;
              return this.connection.stop();
            case 2:
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              console.error('SignalR Stop Error:', _t4);
            case 4:
              this.connection = null;
              this.isConnected = false;
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }() // 重连 - 优化版
  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this$connection,
        _this$connection2,
        _this$connection3,
        _this5 = this;
      if (this.reconnectTimer) {
        return;
      }
      if (((_this$connection = this.connection) === null || _this$connection === void 0 ? void 0 : _this$connection.state) === signalR.HubConnectionState.Connected || ((_this$connection2 = this.connection) === null || _this$connection2 === void 0 ? void 0 : _this$connection2.state) === signalR.HubConnectionState.Connecting || ((_this$connection3 = this.connection) === null || _this$connection3 === void 0 ? void 0 : _this$connection3.state) === signalR.HubConnectionState.Reconnecting) {
        return;
      }

      // 添加重连计数器
      if (!this.reconnectCount) {
        this.reconnectCount = 0;
      }
      var delay = Math.min(this.reconnectDelay * Math.pow(1.5, this.reconnectCount), this.maxReconnectDelay);

      // console.log(`计划在 ${delay}ms 后进行第 ${this.reconnectCount + 1} 次重连尝试`)

      this.reconnectTimer = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var currentToken, _t5, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _this5.reconnectTimer = null;
              _this5.reconnectCount++;

              // 检查token是否有效，如果token过期，需要先获取新token
              _context6.n = 1;
              return _this5.getConnectionToken(null, _this5.forceRefreshOnNextConnect);
            case 1:
              currentToken = _context6.v;
              if (currentToken) {
                _context6.n = 2;
                break;
              }
              console.error('Token不存在，无法重连，可能需要重新登录');
              return _context6.a(2);
            case 2:
              if (!(_this5.connection && _this5.connection.state !== signalR.HubConnectionState.Disconnected)) {
                _context6.n = 6;
                break;
              }
              _context6.p = 3;
              _context6.n = 4;
              return _this5.connection.stop();
            case 4:
              _context6.n = 6;
              break;
            case 5:
              _context6.p = 5;
              _t5 = _context6.v;
              console.error('停止现有连接失败:', _t5);
            case 6:
              // 考虑重新创建连接实例，以避免潜在的连接状态问题
              if (_this5.reconnectCount > 3 || !_this5.connection) {
                _this5.connection = _this5.createConnection();
                _this5.attachConnectionHandlers();
              }
              _context6.p = 7;
              _context6.n = 8;
              return _this5.connection.start();
            case 8:
              _this5.isConnected = true;
              _this5.reconnectCount = 0; // 重连成功后重置计数器

              // 重连成功后刷新通知列表
              store.dispatch('dashboard/refreshTodoList');

              // 重新启动心跳
              _this5.startHeartbeat();
              _this5.startConnectionMonitor();
              _context6.n = 10;
              break;
            case 9:
              _context6.p = 9;
              _t6 = _context6.v;
              console.error('SignalR Reconnection Error:', _t6);
              _this5.forceRefreshOnNextConnect = _this5.shouldRefreshForClose(_t6);

              // 如果多次尝试仍然失败，增加延迟时间
              if (_this5.reconnectCount < 10) {
                _this5.reconnect();
              } else {
                // console.log('已达到最大重连次数，停止自动重连')
                // 可以考虑通知用户手动刷新页面
              }
            case 10:
              return _context6.a(2);
          }
        }, _callee6, null, [[7, 9], [3, 5]]);
      })), delay);
    }

    // 注册事件处理器
  }, {
    key: "registerEventHandlers",
    value: function registerEventHandlers() {
      var _this6 = this;
      if (!this.connection) return;

      // 通知事件
      this.connection.on('ReceiveNotification', function (notification) {
        // console.log('Received notification:', notification)

        // 检查通知是否已经显示过
        if (_this6.displayedNotifications.has(notification.id.toString())) {
          // console.log('通知已显示过，忽略:', notification.id)
          return;
        }

        // 显示通知
        Message({
          message: notification.title,
          type: 'info',
          duration: 5000,
          onClose: function onClose() {
            // 可选：通知关闭时标记为已读
            _this6.markAsRead(notification.id);
          }
        });

        // 记录已显示的通知ID
        _this6.displayedNotifications.add(notification.id.toString());
        _this6.saveDisplayedNotifications();

        // 更新待办
        if (notification.type === 'Todo') {
          store.dispatch('dashboard/refreshTodoList');
        }
      });

      // 在线用户列表更新事件
      this.connection.on('OnlineUserList', function (onlineUserData) {
        // console.log('在线用户列表更新:', onlineUserData)

        // 可以在这里更新 store 中的在线用户数据
        if (store.dispatch) {
          store.dispatch('user/updateOnlineUsers', {
            realName: onlineUserData.realName,
            online: onlineUserData.online,
            userList: onlineUserData.userList || []
          });
        }

        // 可以根据需要显示用户上线/下线提示
        if (onlineUserData.realName && typeof onlineUserData.online === 'boolean') {
          // const statusText = onlineUserData.online ? '上线' : '下线'
          // console.log(`用户${onlineUserData.realName}已${statusText}`)
        }
      });

      // 强制下线事件
      this.connection.on('ForceOffline', function (reason) {
        console.warn('被强制下线:', reason);
        Message({
          message: "\u60A8\u5DF2\u88AB\u7BA1\u7406\u5458\u5F3A\u5236\u4E0B\u7EBF\uFF1A".concat(reason),
          type: 'warning',
          duration: 8000
        });

        // 可以在这里执行登出逻辑
        if (store.dispatch) {
          store.dispatch('user/logout');
        }
      });

      // 站内公告事件
      this.connection.on('PublicNotice', function (notice) {
        Message({
          message: notice.title || notice.content,
          type: 'info',
          duration: 10000
        });
      });

      // 接收消息事件 → 分发到 chat store
      this.connection.on('ReceiveMessage', function (message) {
        // console.log('[SignalR] 收到消息:', message)
        store.dispatch('chat/receiveMessage', message);
      });

      // 已读游标变更事件
      this.connection.on('ReceiveReadCursorChanged', function (payload) {
        store.dispatch('chat/updateReadCursor', payload);
      });

      // 消息撤回事件
      this.connection.on('ReceiveMessageRecalled', function (payload) {
        store.dispatch('chat/handleMessageRecalled', payload);
      });

      // 课程提醒事件
      this.connection.on('ReceiveCourseReminder', function (reminder) {
        Message({
          message: "\u8BFE\u7A0B\u63D0\u9192\uFF1A".concat(reminder.title || reminder.content),
          type: 'info',
          duration: 6000
        });
      });

      // 可以根据需要添加更多事件处理
    }

    // 标记通知为已读
  }, {
    key: "markAsRead",
    value: function markAsRead(notificationId) {
      if (this.connection && this.isConnected) {
        this.connection.invoke('MarkNotificationAsRead', notificationId).catch(function (err) {
          return console.error('标记通知已读失败:', err);
        });
      }
    }

    // 标记所有通知为已读
  }, {
    key: "markAllAsRead",
    value: function markAllAsRead() {
      if (this.connection && this.isConnected) {
        this.connection.invoke('MarkAllNotificationsAsRead').catch(function (err) {
          return console.error('标记所有通知已读失败:', err);
        });
      }
    }

    // 清除通知历史记录（可以在用户注销时调用）
  }, {
    key: "clearNotificationHistory",
    value: function clearNotificationHistory() {
      this.displayedNotifications.clear();
      localStorage.removeItem('displayedNotifications');
    }

    // 添加一个检查会话方法，定期验证token有效性
  }, {
    key: "checkSession",
    value: function checkSession() {
      // 这里可以调用一个轻量级API来检查token是否有效
      // 如果发现token无效，可以触发重新登录流程
    }

    // 添加一个公共方法，允许手动重连
  }, {
    key: "manualReconnect",
    value: function manualReconnect() {
      // console.log('用户触发手动重连')
      this.reconnectCount = 0; // 重置重连计数
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      this.reconnect();
    }

    // 添加网络状态监听
  }, {
    key: "listenToNetworkChanges",
    value: function listenToNetworkChanges() {
      var _this7 = this;
      window.addEventListener('online', function () {
        // console.log('网络已恢复连接，尝试重连SignalR')
        if (!_this7.isConnected) {
          _this7.reconnectCount = 0; // 重置重连计数
          _this7.reconnect();
        }
      });
      window.addEventListener('offline', function () {
        _this7.isConnected = false;
      });
    }

    // 添加连接状态诊断方法
  }, {
    key: "diagnoseConnection",
    value: function () {
      var _diagnoseConnection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var token, tokenParts, pingResponse, _t7;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              // console.log('开始连接诊断...')

              // 检查网络状态
              // const online = navigator.onLine
              // console.log(`网络状态: ${online ? '在线' : '离线'}`)

              // 检查当前连接状态
              if (this.connection) {
                // console.log(`SignalR连接状态: ${this.connection.state}`)
                // console.log(`传输类型: ${this.connection.transport?.name || '未知'}`)
              } else {
                // console.log('SignalR连接未初始化')
              }

              // 检查token有效性
              token = getStoredToken();
              if (token) {
                try {
                  // 简单检查token格式
                  tokenParts = token.split('.');
                  if (tokenParts.length !== 3) {
                    console.warn('Token格式可能不正确');
                  } else {
                    // 检查token是否过期
                    try {
                      // const payload = JSON.parse(atob(tokenParts[1]))
                      // const expTime = payload.exp * 1000
                      // const now = Date.now()
                      // console.log(`Token过期时间: ${new Date(expTime).toLocaleString()}`)
                      // console.log(`当前时间: ${new Date(now).toLocaleString()}`)
                      // console.log(`Token状态: ${expTime > now ? '有效' : '已过期'}`)
                    } catch (e) {
                      console.warn('无法解析token内容:', e);
                    }
                  }
                } catch (e) {
                  console.error('检查token时出错:', e);
                }
              } else {
                console.warn('未找到token');
              }

              // 检查服务器可达性
              _context7.p = 1;
              _context7.n = 2;
              return fetch('/api/health', {
                method: 'GET'
              });
            case 2:
              pingResponse = _context7.v;
              if (pingResponse.ok) {
                // console.log('服务器可达')
              } else {
                console.warn("\u670D\u52A1\u5668\u54CD\u5E94\u5F02\u5E38: ".concat(pingResponse.status));
              }
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t7 = _context7.v;
              console.error('服务器不可达:', _t7);
            case 4:
              return _context7.a(2, true);
          }
        }, _callee7, this, [[1, 3]]);
      }));
      function diagnoseConnection() {
        return _diagnoseConnection.apply(this, arguments);
      }
      return diagnoseConnection;
    }() // 添加时区转换的帮助方法
  }, {
    key: "formatLogTime",
    value: function formatLogTime(date) {
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'Asia/Shanghai'
      };
      return new Date(date).toLocaleString('zh-CN', options);
    }

    // 添加自定义日志方法
  }, {
    key: "logInfo",
    value: function logInfo(message) {
      // const timestamp = this.formatLogTime(new Date())
      // console.log(`[${timestamp}] SignalR: ${message}`)
    }
  }, {
    key: "logError",
    value: function logError(message, error) {
      var timestamp = this.formatLogTime(new Date());
      console.error("[".concat(timestamp, "] SignalR Error: ").concat(message), error);
    }

    // 添加事件监听方法
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (this.connection) {
        this.connection.on(eventName, callback);
      }
    }

    // 添加事件移除方法
  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (this.connection) {
        this.connection.off(eventName, callback);
      }
    }

    // 添加调用服务端方法
  }, {
    key: "invoke",
    value: function () {
      var _invoke = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(methodName) {
        var _this$connection4,
          _len,
          args,
          _key,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!(this.connection && this.isConnected)) {
                _context8.n = 2;
                break;
              }
              for (_len = _args8.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = _args8[_key];
              }
              _context8.n = 1;
              return (_this$connection4 = this.connection).invoke.apply(_this$connection4, [methodName].concat(args));
            case 1:
              return _context8.a(2, _context8.v);
            case 2:
              throw new Error('SignalR connection is not established');
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function invoke(_x3) {
        return _invoke.apply(this, arguments);
      }
      return invoke;
    }()
  }]);
}();
export default new SignalRService();